import React from "react";
import dataTeam from "../../../data.json";
const URL = require("../../../constants");

const Team = () => {
	return (
		<>
			<section className="pos-r right o-hidden pb-0" >
				<div className="container-fluid p-0">
					<div className="row text-center">
						<div className="col-lg-6 col-md-12 ml-auto mr-auto">
							<div className="section-title">
								<div className="title-effect title-effect-2">
									<div className="ellipse wow bounceInRight"></div>{" "}
									<i className="la la-users"></i>
								</div>
								<h2 className="title wow bounceInRight">
									{dataTeam.data.home[0].content.team.title}
								</h2>
							</div>
						</div>
						<div className="col-lg-12 col-md-10 ml-auto mr-auto wow bounceInRight">
							<div
								className="owl-carousel owl-theme"
								data-center="true"
								data-items="5"
								data-dots="false"
								data-lg-items="5"
								data-md-items="3"
								data-sm-items="2"
								data-autoplay="true"
							>
								{dataTeam.data.home[0].content.team.members.map(
									(member, index) => (
										<div className="item" key={index}>
											<div className="team-member">
												<div className="team-images">
													<img
														className="img-fluid"
														src={`${URL.img_url}${member["img_url"]}`}
														alt=""
													/>
													<a
														className="team-link"
														href={member["link"]}
													>
														<i className="la la-external-link"></i>
													</a>
												</div>
												<div className="team-description">
													<h5 className="font-weight-bold">{member["name"]}</h5>
												</div>
											</div>
										</div>
									)
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default Team;
